/**
 * Component Registry for Glen Arbors Apartments
 * 
 * Inherits from @vibesites-dietz-property-group/theme-prestige and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-dietz-property-group/theme-prestige/registry';
import { Header } from './components/Header';
import { Footer } from './components/Footer';

/**
 * Property-specific component overrides.
 * Header / Footer are forked locally so the logo sizing can be tuned for this
 * property (className-only swaps on the logo <VibesitesImage> elements).
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  Header,
  Footer,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
